<template>
  <main id="main-container">
    <Hero title="Notificaciones" page="Notificaciones" />
    <div class="content">
      <Card>
        <template v-slot:header>
          <h5 class="card-category pull-right"></h5>
          <h4 class="card-title">Ubicacion de Mis dispositivos</h4>
        </template>
        <div id="map-wrap" :style="height">
          <l-map :zoom="m.zoom" :center="m.center">
            <l-circle-marker :lat-lng="m.my_position" v-if="my_position" />
            <l-tile-layer
              url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
            ></l-tile-layer>
            <!-- Marcadores de los dispositivos -->
            <l-marker
              v-for="(device, index) in $store.state.devices"
              :key="index"
              :lat-lng="[device.location.lat, device.location.lng]"
              @click="viewMaps(device.location.lat, device.location.lng)"
            >
            <l-tooltip :content="device.name" :options="{permanent: true}"></l-tooltip>

            </l-marker>
            <l-control-scale />
          </l-map>
        </div>
      </Card>
    </div>
  </main>
</template>

<script>
import "leaflet/dist/leaflet.css";
import {
  LMap,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LControlScale,
  LPopup,
  LTooltip
} from "@vue-leaflet/vue-leaflet";
import emitter from "@/eventBus";
export default {
  name: "openStreetLocation",
  components: {
    LMap,
    LTileLayer,
    LCircleMarker,
    LMarker,
    LControlScale,
    LPopup,
    LTooltip
  },
  data() {
    return {
      maps_link: "",
      nowTime: Date.now(),
      time: Date.now(),
      size: "grande",
      height: "height: 75vh",
      my_position: false,
      position: false,
      m: {
        my_position: [0, 0],
        position: [0, 0],
        center: [0, 0],
        marker: [0, 0],
        zoom: 1,
      },

      topic: "",
    };
  },

  mounted() {
    this.geolocate();
  },
  methods: {

    viewMaps(lat, long){
      const link = `https://maps.google.com/?q=${lat},${long}`
      window.open(link, "_blank");

    },
    getLatLng(position) {
      return position;
    },

    changeSize() {
      if (this.height == "height: 75vh") {
        this.height = "height: 50vh";
        this.size = "Grande";
      } else {
        this.height = "height: 75vh";
        this.size = "Pequeño";
      }
    },

    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        // console.log(position)
        const my_position = [
          position.coords.latitude,
          position.coords.longitude,
        ];
        this.m.center = my_position;
        this.m.my_position = my_position;
        this.marker = my_position;
        this.m.zoom = 8;
        this.my_position = true;
      });
      return this.m.center;
    },
  },
};
</script>
